import { createDinero } from '@mr-yum/frontend-core/dist/services/createDinero'
import {
  ListItem,
  ListItemContent,
  ReceiptOutlineIcon,
} from '@mr-yum/frontend-ui'
import { Address } from 'components/Ordering/Address'
import { OrderingWindow } from 'components/Ordering/OrderingWindow'
import { TableNumberLabel } from 'components/TableNumber/TableNumberLabel'
import {
  GuestVenueConfirmationPartsFragment,
  OrderConfirmationPartsFragment,
  OrderingType,
} from 'lib/gql'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const ORDERING_TYPES_WITH_ADDRESS = [
  OrderingType.Catering,
  OrderingType.Counter,
  OrderingType.InVenue,
  OrderingType.PickUp,
]

const getOrderLabel = (orderingType: OrderingType) => {
  switch (orderingType) {
    case OrderingType.Delivery:
      return <FormattedMessage defaultMessage="Delivery order" id="v1bH/u" />
    case OrderingType.PickUp:
      return <FormattedMessage defaultMessage="Pickup order" id="J6GBGf" />
    default:
      return <FormattedMessage defaultMessage="Order for" id="WXeSxn" />
  }
}

interface OrderSummaryProps {
  order: OrderConfirmationPartsFragment
  venue?: GuestVenueConfirmationPartsFragment | null
}

export const OrderSummary = ({ order, venue }: OrderSummaryProps) => {
  const orderingType = order.orderingType
  const startDate = order.orderingWindowStartDate
  const endDate = order.orderingWindowEndDate
  const label = getOrderLabel(orderingType)
  const shouldShowAddress =
    ORDERING_TYPES_WITH_ADDRESS.includes(orderingType) ||
    orderingType === OrderingType.Delivery
  const showTableLabel = !shouldShowAddress

  const tableLabel = showTableLabel && (
    <TableNumberLabel
      shortText={venue?.orderingType?.tableShortText}
      number={order.tableNumber}
      area={order.tableArea}
    />
  )

  const address = shouldShowAddress && (
    <Address
      location={
        orderingType === OrderingType.Delivery
          ? order.location
          : venue?.location
      }
      className="max-w-[24ch] my-body-sm"
    />
  )

  const descriptionContent = (
    <div>
      {address}
      {startDate && (
        <OrderingWindow
          orderingType={orderingType}
          startDate={startDate}
          endDate={endDate}
          className="my-body-sm"
        />
      )}
    </div>
  )

  return (
    <ListItem size="lg">
      <ListItemContent
        label={
          <p className="space-between flex gap-4 my-body-md-bold">
            <span className="grow">
              {label} {tableLabel}
            </span>
            {venue?.currency && (
              <span className="shrink-0 text-right">
                {createDinero(order.totalInCents, venue.currency).toFormat()}
              </span>
            )}
          </p>
        }
        description={shouldShowAddress ? descriptionContent : undefined}
        size="lg"
        leftIcon={<ReceiptOutlineIcon className="self-start" />}
      />
    </ListItem>
  )
}
